// src/pages/MiCuentaPage.js 
import React, { useState, useEffect } from 'react';
import './MiCuentaPage.css';
import MiCuentaPageDetails from './MiCuentaPageDetails';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

function MiCuentaPage() {
  const { login, logout, isLoggedIn, userId, userRole } = useAuth();
  console.log("userId recibido en MiCuentaPage:", userId);

  const [showSignUpModal, setShowSignUpModal] = useState(false);
  const [email, setEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (userId && userRole === 'sponsor') {
      navigate('/mis-eventos');
    }
  }, [userId, userRole, navigate]);
  

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");
  
    if (!email || !password) {
      setErrorMessage("Todos los campos son obligatorios.");
      return;
    }
  
    const result = await login(email, password);
    if (result.success) {
      if (result.role === 'sponsor') {
        navigate("/mis-eventos");
      } else {
        navigate("/cart");
      }
    } else {
      setErrorMessage(result.message);
    }
  };
  
  const handleLogout = () => {
    logout();
    navigate("/"); // 🔹 Redirige al home después de cerrar sesión
  };
  

  const handleSignUpToggle = () => {
    setShowSignUpModal(!showSignUpModal);
    setErrors({});
    setSuccessMessage('');
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (email !== confirmEmail) newErrors.email = 'Los correos electrónicos no coinciden';
    if (password !== confirmPassword) newErrors.password = 'Las contraseñas no coinciden';
    if (password.length < 8) newErrors.passwordLength = 'La contraseña debe tener al menos 8 caracteres';
  
    setErrors(newErrors);
  
    if (Object.keys(newErrors).length === 0) {
      const userData = {
        name: document.getElementById("first-name").value,
        lastName: document.getElementById("last-name").value,
        email: email,
        password: password,
        gender: document.getElementById("gender").value,
        birthDate: document.getElementById("birth-date").value,
        identificationType: document.getElementById("id-type").value,
        identificationNumber: document.getElementById("id-number").value,
        country: "República Dominicana",
        stateProvince: document.getElementById("state").value,
        phone: document.getElementById("phone").value,
        role: "customer"  // 🔹 Se envía siempre como "customer"
      };
  
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/users/register`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(userData)
        });
  
        if (response.ok) {
          //setSuccessMessage("Se ha enviado un correo electrónico a su cuenta para confirmar su registro.");
          const result = await login(email, password);
        if (result.success) {
          if (result.role === 'sponsor') {
            navigate("/mis-eventos");
          } else {
            navigate("/cart");
          }
        } else {
          // Si por alguna razón el login falla, mostrar mensaje
          setErrorMessage(result.message || "No se pudo iniciar sesión automáticamente.");
        }
        } else {
          const errorData = await response.json();
          setErrorMessage(errorData.message || "Error en el registro.");
        }
      } catch (error) {
        setErrorMessage("No se pudo conectar con el servidor.");
      }
    }
  };
  

  // Show MiCuentaPageDetails if logged in
  if (isLoggedIn) {
    return (
      <div className="mi-cuenta-container">
         <MiCuentaPageDetails userId={userId} />
      </div>
    );
  }  

  return (
    <div className="mi-cuenta-container">
      <div className="login-box">
        <h1>Iniciar Sesión</h1>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <input 
              type="email" 
              id="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input 
              type="password" 
              id="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
            />
          </div>
          <button type="submit" className="login-button">Iniciar Sesión</button>
        </form>
        <div className="account-options">
          <a href="/forgot-password">¿Olvidaste tu contraseña?</a>
          <p>¿No tienes cuenta? <button onClick={handleSignUpToggle} className="signup-toggle">Regístrate</button></p>
        </div>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>

      {showSignUpModal && (
        <div className="modal-overlay" onClick={handleSignUpToggle}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleSignUpToggle}>&times;</button>
            <h2>Registro</h2>
            {successMessage ? (
              <div className="success-message">
                {successMessage}
              </div>
            ) : (
              <form className="signup-form" onSubmit={handleSignUp}>
                <div className="form-group">
                  <label htmlFor="email">Correo Electrónico</label>
                  <input 
                    type="email" 
                    id="email" 
                    value={email} 
                    onChange={(e) => setEmail(e.target.value)} 
                    required 
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email-confirm">Confirma Correo Electrónico</label>
                  <input 
                    type="email" 
                    id="email-confirm" 
                    value={confirmEmail} 
                    onChange={(e) => setConfirmEmail(e.target.value)} 
                    required 
                    onPaste={(e) => e.preventDefault()} 
                    onCopy={(e) => e.preventDefault()} 
                  />
                  {errors.email && <span className="error-message">{errors.email}</span>}
                </div>
                <div className="form-group">
                  <label htmlFor="password">Contraseña</label>
                  <input 
                    type="password" 
                    id="password" 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)} 
                    minLength="8"
                    required 
                  />
                  {errors.passwordLength && <span className="error-message">{errors.passwordLength}</span>}
                </div>
                <div className="form-group">
                  <label htmlFor="password-confirm">Confirma Contraseña</label>
                  <input 
                    type="password" 
                    id="password-confirm" 
                    value={confirmPassword} 
                    onChange={(e) => setConfirmPassword(e.target.value)} 
                    minLength="8"
                    required 
                    onPaste={(e) => e.preventDefault()} 
                    onCopy={(e) => e.preventDefault()} 
                  />
                  {errors.password && <span className="error-message">{errors.password}</span>}
                </div>
                <div className="form-group">
                  <label htmlFor="gender">Sexo</label>
                  <select id="gender">
                    <option>Femenino</option>
                    <option>Masculino</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="first-name">Nombre(s)</label>
                  <input type="text" id="first-name" required />
                </div>
                <div className="form-group">
                  <label htmlFor="last-name">Apellidos</label>
                  <input type="text" id="last-name" required />
                </div>
                <div className="form-group">
                  <label htmlFor="birth-date">Fecha de nacimiento</label>
                  <input type="date" id="birth-date" required />
                </div>
                <div className="form-group">
                  <label htmlFor="id-type">Tipo de Identificación</label>
                  <select id="id-type" required>
                    <option value="cedula">Cédula</option>
                    <option value="rnc">RNC</option>
                    <option value="pasaporte">Pasaporte</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="id-number">Número de Identificación</label>
                  <input type="text" id="id-number" required />
                </div>
                <div className="form-group">
                  <label htmlFor="country">País</label>
                  <input type="text" id="country" defaultValue="República Dominicana" disabled />
                </div>
                <div className="form-group">
                  <label htmlFor="state">Estado/Provincia</label>
                  <select id="state" required>
                    <option value="">- Selecciona -</option>
                    <option value="Azua">Azua</option>
                    <option value="Bahoruco">Bahoruco</option>
                    <option value="Barahona">Barahona</option>
                    <option value="Dajabón">Dajabón</option>
                    <option value="Distrito Nacional">Distrito Nacional</option>
                    <option value="Duarte">Duarte</option>
                    <option value="Elías Piña">Elías Piña</option>
                    <option value="El Seibo">El Seibo</option>
                    <option value="Espaillat">Espaillat</option>
                    <option value="Hato Mayor">Hato Mayor</option>
                    <option value="Hermanas Mirabal">Hermanas Mirabal</option>
                    <option value="Independencia">Independencia</option>
                    <option value="La Altagracia">La Altagracia</option>
                    <option value="La Romana">La Romana</option>
                    <option value="La Vega">La Vega</option>
                    <option value="María Trinidad Sánchez">María Trinidad Sánchez</option>
                    <option value="Monseñor Nouel">Monseñor Nouel</option>
                    <option value="Monte Cristi">Monte Cristi</option>
                    <option value="Monte Plata">Monte Plata</option>
                    <option value="Pedernales">Pedernales</option>
                    <option value="Peravia">Peravia</option>
                    <option value="Puerto Plata">Puerto Plata</option>
                    <option value="Samaná">Samaná</option>
                    <option value="San Cristóbal">San Cristóbal</option>
                    <option value="San José de Ocoa">San José de Ocoa</option>
                    <option value="San Juan">San Juan</option>
                    <option value="San Pedro de Macorís">San Pedro de Macorís</option>
                    <option value="Sánchez Ramírez">Sánchez Ramírez</option>
                    <option value="Santiago">Santiago</option>
                    <option value="Santiago Rodríguez">Santiago Rodríguez</option>
                    <option value="Santo Domingo">Santo Domingo</option>
                    <option value="Valverde">Valverde</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Teléfono Móvil</label>
                  <input type="tel" id="phone" required />
                </div>
                <button type="submit" className="register-button">Registrar</button>
              </form>
              
            )}
            
          </div>
        </div>
      )}
      

    </div>
  );
}

export default MiCuentaPage;
